import img21a from '../../../assets/gallery/21d/21d-01-HOME_ST-2021-200x300cm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img21a,
    description: "2021",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];

export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/21d/data21d.js